import { render, staticRenderFns } from "./errorModal.vue?vue&type=template&id=135ce384&scoped=true&"
import script from "./errorModal.vue?vue&type=script&lang=js&"
export * from "./errorModal.vue?vue&type=script&lang=js&"
import style0 from "./errorModal.vue?vue&type=style&index=0&id=135ce384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ce384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('135ce384')) {
      api.createRecord('135ce384', component.options)
    } else {
      api.reload('135ce384', component.options)
    }
    module.hot.accept("./errorModal.vue?vue&type=template&id=135ce384&scoped=true&", function () {
      api.rerender('135ce384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/dev/joinTeam/partials/errorModal.vue"
export default component.exports